"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultHeaderStyles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _styles = require("@material-ui/core/styles");
var _TablePagination = _interopRequireDefault(require("./TablePagination"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultHeaderStyles = {
  root: {
    '@media print': {
      display: 'none'
    }
  }
};
exports.defaultHeaderStyles = defaultHeaderStyles;
var TableHeader = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableHeader, _react$default$Compon);
  function TableHeader() {
    _classCallCheck(this, TableHeader);
    return _possibleConstructorReturn(this, _getPrototypeOf(TableHeader).apply(this, arguments));
  }
  _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        options = _this$props.options,
        rowCount = _this$props.rowCount,
        page = _this$props.page,
        rowsPerPage = _this$props.rowsPerPage,
        changeRowsPerPage = _this$props.changeRowsPerPage,
        changePage = _this$props.changePage,
        classes = _this$props.classes;
      return /*#__PURE__*/_react.default.createElement(_Table.default, {
        className: classes.root
      }, options.customFooter ? options.customFooter(rowCount, page, rowsPerPage, changeRowsPerPage, changePage, options.textLabels.pagination) : options.pagination && /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
        count: rowCount,
        page: page,
        rowsPerPage: rowsPerPage,
        changeRowsPerPage: changeRowsPerPage,
        changePage: changePage,
        component: "div",
        options: options
      }));
    }
  }]);
  return TableHeader;
}(_react.default.Component);
_defineProperty(TableHeader, "propTypes", {});
var _default = (0, _styles.withStyles)(defaultHeaderStyles, {
  name: 'MUIDataTableHeader'
})(TableHeader);
exports.default = _default;